import { paginatedTransform, rawTransform } from 'src/services/skuit/utils'
import { PaginatedResponse, Pallet } from '../../api/models'

import { API, CustomAxiosConfig } from './types'

import fileDownload from 'js-file-download'

export interface ExportProps {
  fields: string[]
}

interface PatchProps {
  guid: string
  data: any
  config?: CustomAxiosConfig
}

export class Pallets {
  api: API

  constructor(api: API) {
    this.api = api
  }

  list = async (config: CustomAxiosConfig = {}): Promise<PaginatedResponse<Pallet>> => {
    const response = await this.api.get('/logistics/pallets', config)
    return paginatedTransform(Pallet)(response.data)
  }

  create = async (data: any = {}, config: CustomAxiosConfig = {}): Promise<Pallet[]> => {
    const response = await this.api.post('/logistics/pallets/bulk', data, config)
    return response.data.map((palletItem: any) => rawTransform(Pallet)(palletItem))
  }

  retrieve = async (guid: string, config: CustomAxiosConfig = {}): Promise<Pallet> => {
    const response = await this.api.get(`/logistics/pallets/${guid}`, config)
    return rawTransform(Pallet)(response.data)
  }

  patch = async ({ guid, data, config = {} }: PatchProps): Promise<Pallet> => {
    const response = await this.api.patch(`/logistics/pallets/${guid}`, data, config)
    return rawTransform(Pallet)(response.data)
  }

  export = async ({ fields }: ExportProps) => {
    const params = { fields: fields.join(',') }
    const response = await this.api.axiosInstance({
      url: 'logistics/pallets/export',
      params,
      responseType: 'blob',
    })
    fileDownload(response.data, 'pallets.csv')
  }
}
